<template>
	<el-container id="mainordenes">
		<el-row :class="!responsive.isMobile ? 'header' : 'headerMobile'">
			<h6 v-if="!responsive.isMobile" class="titulo">{{ tituloResumen.toUpperCase() }}</h6>
			<el-row type="flex" justify="space-between">
				<el-col :xs="18" :sm="24" :md="24" :lg="24" :xl="24">
					<template v-if="responsive.isMobile">
						<p class="titleMobile">Ordenes compra</p>
						<p class="entidadMobile">
							{{ entidadSelected.descri_entidad }}
						</p>
					</template>
				</el-col>
			</el-row>
		</el-row>
		<el-tabs type="card" :stretch="responsive.isMobile" style="margin-bottom: 0px !important;">
			<el-tab-pane label="Nueva orden de compra">
				<el-row :class="!responsive.isMobile ? 'header' : 'headerMobile'" type="flex" justify="center">
					<el-col :xs="24" :sm="23" :md="22" :lg="21" :xl="18">
						<el-row>
							<el-card
								:body-style="{ padding: 0 }"
								:style="!responsive.isMobile ? 'height: auto; margin-top: 20px' : 'height: auto; margin-top: 5px'"
							>
								<el-col v-if="!responsive.isMobile" :span="16" class="entidad"> </el-col>
								<el-col
									:xs="21"
									:sm="21"
									:md="6"
									:lg="6"
									:xl="6"
									:style="!responsive.isMobile ? 'padding: 20px' : 'padding: 20px 5px;'"
								>
									<el-input
										placeholder="Buscar productos"
										v-model="patronoc"
										@change="onChangeSearch"
										suffix-icon="el-icon-search"
										clearable
										size="medium"
										ref="patronoc"
									>
									</el-input>
								</el-col>
								<el-col v-if="responsive.isMobile" :span="3" style="padding: 15px 10px;">
									<el-button type="text" size="mini" @click="drawer = true">
										<i class="el-icon-linear-funnel" style="font-size: 25px;" />
									</el-button>
								</el-col>
								<el-col :span="2" style="padding: 20px 20px 20px 0px;" v-if="!responsive.isMobile">
									<el-badge
										:hidden="$store.state.ordenescompra.carrito.length === 0"
										:value="$store.state.ordenescompra.carrito.length"
									>
										<el-button type="info" size="mini" @click="displayCarrito">
											<i class="el-icon-document"></i>
										</el-button>
									</el-badge>
								</el-col>
							</el-card>
						</el-row>
					</el-col>
				</el-row>
				<ordenesProductos />
				<carrito :v-if="visibleCarrito" :visible="visibleCarrito" />
			</el-tab-pane>
			<el-tab-pane label="Ordenes de compra realizadas"><ordenes-realizadas></ordenes-realizadas></el-tab-pane>
		</el-tabs>
		<el-drawer
			:visible.sync="drawer"
			direction="rtl"
			:size="responsive.isMobile ? '80%' : '310px'"
			:modal="!responsive.isMobile"
			:show-close="!responsive.isMobile"
			:style="{ marginTop: responsive.isMobile ? '60px' : '' }"
		>
			<filtros modulo="ocompra" />
		</el-drawer>
	</el-container>
</template>
<script>
import ordenesProductos from '@/views/ordenesCompra/OrdenesProductos.vue';
import carrito from '@/views/ordenesCompra/CarritoOrdenes.vue';
import OrdenesRealizadas from '@/views/ordenesCompra/OrdenesRealizadas.vue';
import filtros from '@/components/Filtros.vue';

export default {
	name: 'ordenescompra',
	inject: ['responsive'],
	components: {
		carrito,
		ordenesProductos,
		OrdenesRealizadas,
		filtros,
	},
	data() {
		return {
			drawer: false,
			filter: {
				patron: '',
				familia_id: '',
				subfamilia_id: '',
				unidad: '',
				presentacion_id: '',
				rubro_id: '',
				subrubro_id: '',
				linea_id: '',
				marca_id: '',
				es_nuevo: false,
				es_promocion: false,
			},
			patronoc: '',
			visibleCarrito: false,
		};
	},
	computed: {
		tituloResumen() {
			return this.$route.name;
		},
		activeProfile() {
			return this.$store.state.perfil.activeProfile;
		},
		entidadSelected() {
			return this.$store.state.perfil.entidadSelected;
		},
	},
	methods: {
		displayCarrito() {
			this.visibleCarrito = !this.visibleCarrito;
		},
		armoLLamada(filter, start, limit, page) {
			filter.patron = this.patronoc;
			let filtros = filter;
			this.filter = filtros;
			this.callProductos({ params: { filtros, start, limit, page } });
		},
		callProductos(params) {
			this.$store.dispatch('loadProductosOrdenes', params);
		},
		onChangeSearch(value, select) {
			this.filter.patron = this.patronoc;
			this.start = 0;
			this.page = 1;
			this.limit = 12;
			let filtros = this.filter,
				start = this.start,
				limit = this.limit,
				page = this.page;
			this.callProductos({ params: { filtros, start, limit, page } });
		},
	},
};
</script>
<style lang="scss">
#mainordenes {
	.mobile {
		.el-date-editor.el-input,
		.el-date-editor.el-input__inner {
			width: 100%;
		}
	}
	.titleMobile {
		visibility: hidden;
		margin: 0px;
	}
	.header {
		background-color: var(--header-background-color);
		border-bottom: 1px solid var(--header-border-color);
		margin-bottom: 20px;
		padding-bottom: 20px;
		h6 {
			font-size: 18px;
		}
		.entidad {
			font-family: 'Open Sans', sans-serif;
			font-size: 23px;
			font-style: normal;
			font-weight: 400;
			letter-spacing: -0.25px;
			font-stretch: normal;
			line-height: 40px;
			padding: 20px;
		}
		.el-row {
			font-size: 15px;
			font-weight: 100;
		}
		.title {
			display: block;
			opacity: 0.5;
			font-size: 12px;
			font-weight: normal;
			font-style: normal;
			font-stretch: normal;
			line-height: 1.67;
			letter-spacing: -0.2px;
		}
		.value {
			display: block;
			font-size: 25px;
			font-weight: normal;
			font-style: normal;
			font-stretch: normal;
			line-height: 0.93;
			letter-spacing: -0.5px;
		}

		.el-tabs {
			position: relative;
			top: 1px;
			.el-tabs__header {
				margin: 0;
				.el-tabs__nav {
					border: 0;
				}
			}
			.el-tabs__item {
				background-color: var(--main-color);
				color: #fff;
				&.is-active {
					background-color: #fff;
					color: var(--main-color);
				}
			}
		}
	}
	.headerMobile {
		background-color: var(--header-background-color);
		border-bottom: 1px solid var(--header-border-color);
		padding-bottom: 10px;
		h6 {
			font-size: 18px;
		}
		.entidadMobile {
			font-family: 'Open Sans', sans-serif;
			padding-left: 10px;
			font-size: 15px;
			font-weight: bold;
			letter-spacing: -0.25px;
			font-stretch: normal;
			margin: 0;
			padding-bottom: 10px;
		}
		.el-row {
			font-size: 15px;
			font-weight: 100;
		}
		.title {
			display: block;
			opacity: 0.5;
			font-size: 12px;
			font-weight: normal;
			font-style: normal;
			font-stretch: normal;
			line-height: 1.67;
			letter-spacing: -0.2px;
		}
		.value {
			display: block;
			font-size: 25px;
			font-weight: normal;
			font-style: normal;
			font-stretch: normal;
			line-height: 0.93;
			letter-spacing: -0.5px;
		}

		.el-tabs {
			position: relative;
			top: 1px;
			.el-tabs__header {
				margin: 0;
				.el-tabs__nav {
					border: 0;
				}
			}
			.el-tabs__item {
				background-color: var(--main-color);
				color: #fff;
				&.is-active {
					background-color: #fff;
					color: var(--main-color);
				}
			}
		}
	}
}
</style>
